// Placeholder icons for held items and their pieces (shared/held.ts) until the art thread draws icon-<id>: a small
// amulet in its boss's colour, whole for an item and broken for a piece. No imports from client modules, so
// client/assets.ts can use it as a stand-in without a cycle.
import { HELD, pieceOf } from '../shared/held.ts';

const BOSS_COLOR: Record<string, [string, string]> = {
  fenrir: ['#7fc8e8', '#2f5f78'],
  typhon: ['#b39cf0', '#4a3a86'],
  hachimata: ['#e07a6a', '#7a2a24'],
};
const cache = new Map<string, string>();

/** A data URL for a held item's or piece's stand-in icon, or '' when `id` is neither. */
export function heldPlaceholder(id: string): string {
  const piece = pieceOf(id);
  const def = HELD[piece ?? id];
  if (!def) return '';
  const hit = cache.get(id);
  if (hit) return hit;
  const [hi, lo] = BOSS_COLOR[def.boss] ?? ['#c8c8c8', '#555'];
  // An amulet on a cord (a round stone in a ring), not a gem: a blue gem reads as a diamond.
  const gem = piece
    ? `<path d="M5 17 A9 9 0 0 1 14 8 L14 13 L10 15 Z" fill="${hi}" stroke="${lo}" stroke-width="1.5" stroke-linejoin="round"/><path d="M18 12 A9 9 0 0 1 26 22 L19 26 L21 19 Z" fill="${hi}" stroke="${lo}" stroke-width="1.5" stroke-linejoin="round" opacity=".85"/>`
    : `<path d="M11 4 Q16 9 21 4" fill="none" stroke="${lo}" stroke-width="2" stroke-linecap="round"/><circle cx="16" cy="18" r="11" fill="${lo}"/><circle cx="16" cy="18" r="8" fill="${hi}"/><circle cx="13.5" cy="15.5" r="2.5" fill="#fff" opacity=".45"/>`;
  const url = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32">${gem}</svg>`)}`;
  cache.set(id, url);
  return url;
}
